// extracted by mini-css-extract-plugin
export var link = "_si-0";